
const workplaceReview =
{
    sectors : 'Secteurs'
};

export default workplaceReview ;